module.exports = () => {
	let style_text = '';
	// 生成padding和margin
	for (let i = 2; i < 151; i += 1) {
		style_text +=
			`
			.p-${i} {padding: ${i/100}rem;}
			.pl-${i},.prl-${i} {padding-left: ${i/100}rem;}
			.pr-${i},.prl-${i} {padding-right: ${i/100}rem;}
			.pb-${i},.ptb-${i} {padding-bottom: ${i/100}rem;}
			.pt-${i},.ptb-${i} {padding-top: ${i/100}rem;}
			.m-${i} {margin: ${i/100}rem;}
			.ml-${i},.mrl-${i} {margin-left: ${i/100}rem;}
			.mr-${i},.mrl-${i} {margin-right: ${i/100}rem;}
			.mb-${i},.mtb-${i} {margin-bottom: ${i/100}rem;}
			.mt-${i},.mtb-${i} {margin-top: ${i/100}rem;}
			`
	}

	// 生成font-size
	for (let i = 10; i < 70; i += 1) {
		style_text += `
		.fs-${i} {font-size:${i}px;}
		`
	}
	
	// 生成line-height
	for (let i = 20; i < 70; i += 1) {
		style_text += `
		.lh-${i} {line-height:${i}px;}
		`
	}

	let style = document.createElement('style');
	style.type = "text/css";
	try {
		style.innerHTML = style_text;
	} catch (ex) {
		style.styleSheet.cssText = style_text; //针对IE
	}
	document.getElementsByTagName("head")[0].appendChild(style);
}



// WEBPACK FOOTER //
// ./src/assets/js/css.js